// jQueryプラグイン
import 'jquery.easing';
/* ----------------------------------------------------------------------------------
ページ内リンクのアニメーション
---------------------------------------------------------------------------------- */
export function pageLinkAnimationFunc() {
	$('html').attr('id', 'pageTop');// トップに戻る時に移動する際のフラグID
	$('a[href^="#"]:not(.notScroll)').each(function() {
		var pageUrl = location.href.split('#')[0];
		if(this.href.indexOf(pageUrl + '#') === 0) {
			var id = this.href.split('#')[1];
			$(this).on('click', function() {
                var resizecheck,position;
                resizecheck = $('#responsibleCheck').width();
                if(resizecheck !=1 ){
                    position = $('#' + id).offset().top - 65;
                   }else{
                    position = $('#' + id).offset().top+1;
                   }
				$('body,html').animate({scrollTop :position}, 1000, 'easeInOutQuart');
				return false;
			});
		}
	});
}


//////////////////
// WEBPACK FOOTER
// ./src/js/common/_pageLinkAnimation.js
// module id = 6
// module chunks = 0